import React, { useEffect, useState } from "react";
import { getGlobalVariables } from "../utils/wkCommon";

export default function SongFilterPanel({
  filters,
  setFilters,
  onApply,
  onClear,
  isEditorMode 
}) {
  const [globals, setGlobals] = useState({});

  useEffect(() => {
    getGlobalVariables([
      "SONG_PRIMARY_LANGUAGE",
      "SONG_EMOTION_TAGS",
      "SONG_KEYWORD_TAGS"
    ]).then(setGlobals);
  }, []);

  function toggle(arr, value) {
    const exists = arr.some(x => x.id === value.id);

    return exists
      ? arr.filter(x => x.id !== value.id)
      : [...arr, value];
  }

  return (
    <div style={{ fontSize: "0.85rem" }}>

      {/* ================= SORT (EDITOR ONLY) ================= */}
      {isEditorMode && (
        <div style={{ marginTop: 16, marginBottom: 12 }}>
          <b>Sort By</b>
          <select
            value={filters.sort || "updatedAt"}
            onChange={(e) =>
              setFilters(f => ({
                ...f,
                sort: e.target.value
              }))
            }
            style={{
              width: "100%",
              padding: "0.5rem",
              borderRadius: "0.5rem",
              border: "1px solid #ddd",
              marginTop: 4
            }}
          >
            <option value="updatedAt">Updated (Terbaru)</option>
            <option value="createdAt">Created (Terbaru)</option>
            <option value="judulLirik">Judul Lirik (A-Z)</option>
            <option value="judulNada">Judul Nada (A-Z)</option>
          </select>
        </div>
      )}

      {/* ================= FILES ================= */}
      {isEditorMode && (
        <div style={{ marginBottom: 12 }}>
          <b>File</b>

          {[
            ["no_file", "Belum ada file"],
            ["no_text_file", "Belum ada text"],
            ["no_slide_file", "Belum ada slide"],
            ["no_audio_file", "Belum ada audio"],
            ["no_video_file", "Belum ada video"]
          ].map(([key, label]) => (
            <label key={key} style={{ display: "block" }}>
              <input
                type="checkbox"
                checked={filters[key] || false}
                onChange={() =>
                  setFilters(f => ({
                    ...f,
                    [key]: !f[key]
                  }))
                }
              />
              {label}
            </label>
          ))}
        </div>
      )}

      {/* ================= LANGUAGE ================= */}
      <div style={{ marginBottom: 12 }}>
        <b>Language</b>
        {(globals.SONG_PRIMARY_LANGUAGE || []).map(i => {
          const value = `${i.zh} ${i.id}`;

          return (
            <label key={i.id} style={{ display: "block" }}>
              <input
                type="checkbox"
                checked={filters.primary_language.includes(value)}
                onChange={() =>
                  setFilters(f => ({
                    ...f,
                    primary_language: f.primary_language.includes(value)
                      ? f.primary_language.filter(x => x !== value)
                      : [...f.primary_language, value]
                  }))
                }
              />
              {i.zh} {i.id}
            </label>
          );
        })}

        {/* EDITOR ONLY */}
        {isEditorMode && (
          <label style={{ display: "block" }}>
            <input
              type="checkbox"
              checked={filters.no_primary_language || false}
              onChange={() =>
                setFilters(f => ({
                  ...f,
                  no_primary_language: !f.no_primary_language
                }))
              }
            />
            (No Primary Language)
          </label>
        )}
      </div>

      {/* ================= EMOTION ================= */}
      <div style={{ marginBottom: 12 }}>
        <b>Emotion</b>
        {(globals.SONG_EMOTION_TAGS || []).map(i => (
          <label key={i.id} style={{ display: "block" }}>
            <input
              type="checkbox"
              checked={filters.emotion_tags.some(x => x.id === i.id)}
              onChange={() =>
                setFilters(f => ({
                  ...f,
                  emotion_tags: toggle(f.emotion_tags, { id: i.id, zh: i.zh })
                }))
              }
            />
            {i.zh} {i.id}
          </label>
        ))}

        {/* EDITOR ONLY */}
        {isEditorMode && (
          <label style={{ display: "block" }}>
            <input
              type="checkbox"
              checked={filters.no_emotion_tags || false}
              onChange={() =>
                setFilters(f => ({
                  ...f,
                  no_emotion_tags: !f.no_emotion_tags
                }))
              }
            />
            (No Emotion Tags)
          </label>
        )}
      </div>

      {/* ================= KEYWORD ================= */}
      <div>
        <b>Keyword</b>
        {(globals.SONG_KEYWORD_TAGS || []).map(i => (
          <label key={i.id} style={{ display: "block" }}>
            <input
              type="checkbox"
              checked={filters.keyword_tags.some(x => x.id === i.id)}
              onChange={() =>
                setFilters(f => ({
                  ...f,
                  keyword_tags: toggle(f.keyword_tags, { id: i.id, zh: i.zh })
                }))
              }
            />
            {i.zh} {i.id}
          </label>
        ))}

        {/* EDITOR ONLY */}
        {isEditorMode && (
          <label style={{ display: "block" }}>
            <input
              type="checkbox"
              checked={filters.no_keyword_tags || false}
              onChange={() =>
                setFilters(f => ({
                  ...f,
                  no_keyword_tags: !f.no_keyword_tags
                }))
              }
            />
            (No Keyword Tags)
          </label>
        )}
      </div>

      {/* ================= ACTIONS ================= */}
      <div style={{ marginTop: 16, display: "flex", gap: 8 }}>
        <button
          className="btn-secondary"
          style={{ flex: 1 }}
          onClick={() => {
            const empty = {
              primary_language: [],
              emotion_tags: [],
              keyword_tags: [],
              no_primary_language: false,
              no_emotion_tags: false,
              no_keyword_tags: false,
              sort: "updatedAt"
            };
            setFilters(empty);
            onClear && onClear(empty);
          }}
        >
          清除 / Clear
        </button>

        <button
          className="btn-primary"
          style={{ flex: 1 }}
          onClick={() => onApply && onApply(filters)}
        >
          套用 / Apply
        </button>
      </div>
    </div>
  );
}